export const state = () => ({
  oddsFormat: process.env.ODDS_FORMAT ?? 'decimal',
  acceptOdds: process.env.ACCEPT_ODDS ?? 'all', //all,higher,none
  timezone: 'Europe/Madrid',
  comboBoost:  null
})

export const mutations = {
  setOddsFormat(state, oddsFormat) {
    state.oddsFormat = oddsFormat;
  },
  setAcceptOdds(state, acceptOdds) {
    state.acceptOdds = acceptOdds;
  },
  setTimezone(state, timezone) {
    state.timezone = timezone;
  },
  setComboBoost(state, value) {
    state.comboBoost = value;
  }
}
